import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { ReactComponent as ArrowDown } from '../../../../../assets/icons/ArrowDown.svg';
import { navigateToNewTab } from '../../../../../utils/toNewTab';

export const entityTypes = {
  MANAGEMENT: 'management',
  ADDRESS: 'address',
  STANDALONE_ADDRESSES: 'standaloneAddresses',
  COMMUNITY: 'sommunity',
};

const ClientBillingNameCell = ({ value, row, rowClick, stateCode }) => {
  const handleRowClick = () => {
    if (row.original.type !== entityTypes.MANAGEMENT) return;
    rowClick({ value });
  };

  const goToPage = () => {
    if (!row.original.id) return;
    if (row.original.type === entityTypes.MANAGEMENT) {
      navigateToNewTab('/db/datahandling/editmanagement/management', {
        id: row.original.id,
        name: value,
        navPage: 'Data Handling',
        subNav: 'Managements',
      });
    } else if (row.original.type === entityTypes.COMMUNITY) {
      navigateToNewTab('/db/datahandling/editcommunity/community', {
        id: row.original.id,
        name: value,
        navPage: 'Data Handling',
        subNav: 'Communities',
      });
    } else {
      navigateToNewTab('/db/datahandling/editaddress/address', {
        id: row.original.id,
        name: value,
        navPage: 'Data Handling',
        subNav: 'Addresses',
        state: stateCode,
      });
    }
  };
  return (
    <Stack
      data-testid="cell_wrapper"
      direction="row"
      sx={{ cursor: 'pointer' }}
      alignItems="center"
      onClick={handleRowClick}
    >
      {row.original.type === entityTypes.MANAGEMENT ? (
        <ArrowDown
          style={{
            marginRight: '8px',
            transform: !row.original.expanded ? 'rotate(-90deg)' : 'none',
            transition: 'transform 0.2s',
          }}
          data-testid="arrow_icon"
        />
      ) : (
        <Box sx={{ width: '40px', height: '24px' }} />
      )}
      <Typography
        sx={{
          textDecoration:
            row.original.type === entityTypes.MANAGEMENT ||
            row.original.type === entityTypes.COMMUNITY
              ? 'underline'
              : 'none',
          fontWeight: row.original.type === entityTypes.MANAGEMENT ? 600 : 500,
          fontSize: row.original.type === entityTypes.MANAGEMENT ? '18px' : '16px',
        }}
        onClick={goToPage}
        data-testid="name_cell"
      >
        {value}
      </Typography>
    </Stack>
  );
};

ClientBillingNameCell.propTypes = {
  value: PropTypes.string,
  row: PropTypes.shape({
    original: PropTypes.shape({
      expanded: PropTypes.bool,
      id: PropTypes.number,
      type: PropTypes.string,
    }),
  }).isRequired,
  rowClick: PropTypes.func,
  stateCode: PropTypes.shape({}).isRequired,
};

ClientBillingNameCell.defaultProps = {
  value: '',
  rowClick: null,
};

export default ClientBillingNameCell;
